import { match } from 'ts-pattern';

import { cleanContentfulId } from '@telialt/utils/src/Contentful/cleanContentfulId';
import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';

import { BlockValuePromptType } from '../../models/Content';
import { transformCta } from '../../utils/transformers';
import { ValuePromptBlockContent, ValuePromptColorVariant, ValuePromptVariant } from './model';

export const transformValuePrompt = (content: BlockValuePromptType): ValuePromptBlockContent => {
    const colorVariant = match<BlockValuePromptType['fields']['colorOption'], ValuePromptColorVariant>(
        cleanContentfulId(content.fields.colorOption),
    )
        .with('color-light-grey', () => 'light-grey')
        .with('color-light-purple', () => 'light-purple')
        .with('color-light-beige', () => 'light-beige')
        .otherwise(() => 'no-background');

    const variant = match<BlockValuePromptType['fields']['displayOption'], ValuePromptVariant>(
        cleanContentfulId(content.fields.displayOption),
    )
        .with('illustrative', () => 'illustrative')
        .with('compact', () => 'compact')
        .otherwise(() => 'illustrative');

    return {
        blockTitle: content.fields.title,
        blockCta: transformCta(content.fields.cta),
        colorVariant,
        variant,
        values: content.fields.values?.map((value) => ({
            heading: {
                tag: !!content.fields.title && variant !== 'compact' ? 'h3' : 'h2',
                title: value.fields.title,
            },
            cta: transformCta(value.fields.cta),
            text: value.fields.subtitle,
            colorVariant,
            variant,
            img: value.fields.icon && {
                src: contentfulImageUrl(value.fields.icon.fields.file?.url),
                alt: value.fields.icon.fields.description,
            },
        })),
    };
};
